const REFRESH_TOKEN_STORAGE_KEY = 'refresh_token';
const REDIRECT_URI_STORAGE_KEY = 'redirect_uri';

export const saveRefreshToken = (refreshToken) => localStorage.setItem(REFRESH_TOKEN_STORAGE_KEY, refreshToken);
export const invalidateRefreshToken = () => localStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY);
export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_STORAGE_KEY);

export const saveRedirectUri = (redirectUri) => sessionStorage.setItem(REDIRECT_URI_STORAGE_KEY, redirectUri);
export const invalidateRedirectUri = () => sessionStorage.removeItem(REDIRECT_URI_STORAGE_KEY);
export const getRedirectUri = () => sessionStorage.getItem(REDIRECT_URI_STORAGE_KEY);